/** @jsxImportSource @emotion/react */
import React from "react";
import { Input, Tag, Tooltip } from "antd";
import * as Styles from "./styles";

interface HexColorInputProps {
  value?: string;
  onChange?: (value: string) => void;
}

const HEX_PATTERN = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;

export const HexColorInput: React.FC<HexColorInputProps> = ({
  value,
  onChange,
}: HexColorInputProps) => {
  const isValidHex = !!value && HEX_PATTERN.test(value);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(event.target.value);
  };

  return (
    <Input
      css={Styles.inputStyle}
      value={value}
      maxLength={7}
      placeholder="#RRGGBB"
      status={value && !isValidHex ? "error" : undefined}
      allowClear
      addonBefore={
        <Tooltip title={isValidHex ? value : "Enter a valid hex color"}>
          <Tag
            css={Styles.swatchStyle}
            color={isValidHex ? value : "default"}
          />
        </Tooltip>
      }
      onChange={handleChange}
    />
  );
};
